/*
 * @Author: your name
 * @Date: 2021-05-06 09:27:04
 * @LastEditTime: 2022-09-19 11:22:44
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\reserve\api.js
 */
// 【当前模块】的api调用配置文件-需要使用的页面引入
export const api = {
  reserve: {
    // 查询预案配置list
    getEmergencySetList: "/bas/emergency/queryEmergencyPlanList.json",
    // 告警处理
    processEmergencyAlarm: "/bas/emergency/processEmergencyAlarm.json",
    // 查询预案管理列表
    getEmergencyPlanList: "bas/emergency/getEmergencyPlanList.json",
    // 查询图片抓拍摄像机
    getDeviceList: "/bas/emergency/queryEmergencyDeviceList.json",
    // 新增预案管理
    addEmergencyPlan: "bas/emergency/addEmergencyPlan.json",
    // 修改预案管理
    updateEmergencyPlan: "bas/emergency/updateEmergencyPlan.json",
    // 删除预案管理
    deleteEmergencyPlan: "bas/emergency/deleteEmergencyPlan.json",
    // 预案管理启动/禁用
    activeEmergencyPlan: "bas/emergency/activeEmergencyPlan.json",
    // 查看预案步骤列表
    getPlanStepList: "bas/emergency/queryEmergencyRecordList.json",
    // 新增预案步骤
    addPlanStep: "bas/planStep/addPlanStep.json",
    // 删除预案步骤
    deletePlanStep: "bas/planStep/deletePlanStep.json",
    // 查询告警类型树
    queryAlarmTree: "bas/emergency/queryAlarmTree.json",
    //查询工作组
    queryWorkGroupByAreaOrDevice:
      "/cms/workGroup/queryWorkGroupByAreaOrDevice.json",
    //查询账户组与账户关系
    queryAccountGroup: "/cms/accountGroup/getAccountByAccountGroup.json",
    // 新增预案执行步骤
    addProcessRecord: "/bas/emergency/addProcessRecord.json",
    //预按步骤更新
    updateProcessRecord: "/bas/emergency/updateEmergencyRecordStep.json",
    //预按升级
    updateLevel: "/bas/emergency/updateEmergencyRecordLevel.json",
    //预案执行报告提交
    addEmergencyReport: "/bas/emergency/addEmergencyReport.json",
    // 下发任务
    addEmergencyTaskInfo: "/bas/taskcenter/addEmergencyTaskInfo.json",
    // 现场处理
    sceneProcess: "/bas/emergency/sceneProcess.json",
    // 获取告警详情
    getAlarmDetail: "/bas/alarmSafeEvent/queryResult.json",
    // 查询预案详情
    queryRecordDetail: "/bas/emergency/queryEmergencyRecordDetail.json",
    // 查询预案执行记录详情
    getRecordDetail: "/bas/emergency/queryEmergencyHistoryRecordDetail.json",
    // 查询短信模板
    querySmsTemplate: "/bas/emergency/querySmsTemplate.json",
    // 批量下发短信：
    batchPushSMS: "/bas/emergency/batchPushSMS.json",
    // 视频
    queryRealTimeVideoRtsp: "/vas/video/queryRealTimeVideoRtsp.json",
    addEmergencyRecordSnapShot:
      "/bas/emergency/addEmergencyRecordSnapShot.json",
    batchEmergencyRecordSnapShot:
      "/bas/emergency/batchEmergencyRecordSnapShot.json",
    //查询应急处理流程列表
    // queryEmergencyHandleProcessList:'/bas/emergency/queryEmergencyHandleProcessList.json',
    queryEmergencyHandleProcessList:
      "/bas/emergency/queryEmergencyHandleProcessListApi.json",
    //查询应急处理流程详情
    queryEmergencyHandleProcessDetail:
      "/bas/emergency/queryEmergencyHandleProcessDetail.json"
  },
  reserveProcess: {
    // 预案执行中应急响应页面中道闸控制接口
    batchControlVehicleBarrier:
      "/bas/vehicleBarrier/batchControlVehicleBarrier.json", // 批量控制道闸开关
    controlVehicleBarrier: "/bas/vehicleBarrier/controlVehicleBarrier.json", // 控制道闸开关
    // 场景列表
    queryDeviceSceneList: "/bms/devicescene/queryDeviceSceneList.json",
    // 对应场景下道闸列表
    queryDeviceSceneDetail: "/bms/devicescene/queryDeviceSceneDetail.json",

    // 短信通知及信息通知下的接口
    // queryWorkShopGroup: '/cms/workgroup/queryWorkShopGroup.json', //查询车间应急组树
    queryWorkShopGroup: "/cms/workgroup/queryWorkShopGroupApi.json", //查询车间应急组树
    queryWorkShopGroupInfo: "cms/workgroup/queryWorkShopGroupInfo.json", //查询车间应急组树中对应的人员
    // queryIntegratedGroup: '/cms/workgroup/queryIntegratedGroup.json', //查询综合应急组树
    queryIntegratedGroup: "/cms/workgroup/queryIntegratedGroupApi.json", //查询综合应急组树
    queryIntegratedGroupInfo: "/cms/workgroup/queryIntegratedGroupInfo.json", //查询综合应急组树中对应的人员
    queryNoticeTemplateList: "/bas/emergency/queryNoticeTemplateList.json", //获取固定模板
    addEmergencySms: "/bas/emergency/addEmergencySms.json", //预案执行短信通知
    queryEmergencyGroup: "/bas/emergency/queryEmergencyGroup.json", //获取选中的应急组和综合组
    addEmergencyInfo: "/bas/emergency/addEmergencyInfo.json", //预案执行信息通知
    queryPersonOrAccountByPage:
      "/bas/emergency/queryPersonOrAccountByPage.json", //根据车间code和综合应急组code查询人员
    getDeviceTree: "/bms/device/queryDeviceWorkGroupDeviceTree.json", //获取摄像机设备树
    getDeviceVideo: "/bms/device/queryFirefightingCameraList.json", //查询设备视频
    queryAlarmDeviceList: "/bas/alarmSafeEvent/queryAlarmDeviceList.json" // 获取告警周边设备
  },
  getCallTemplate: "/bas/remotecall/queryRemoteCallTemplate.json", //获取终端模板
  getCallDevice: "/bms/device/getDeviceListByPageApi.json", //获取广播设备
  queryNotifyRecordByPage: "/bas/emergency/queryNotifyRecordByPage.json", //获取预案回执
  setVolume: '/bas/remotecall/setVolume.json', // 设置广播设备音量

  queryRealTimeVideoRtsp: "/vas/video/queryRealTimeVideoRtsp.json",
  getSnap: "/icc/admin/getSnapImageUrlByChannelCode",
};
